import { UtmService } from '../services';

export const provideUtmService = () => {
  return {
    provide: UtmService,
    useFactory: () => {
      return new UtmService();
    }
  };
};
